import styles from './styles.module.scss'

export default function News({ data }) {
  return (
    <a href={data.link} target="_blank" rel="noopener noreferrer nofollow">
      <div className={styles.container}>
        <div className={styles.backgroundWrapper}>
          <img
            className={styles.background}
            src={data.img}
            alt="NewsBackground"
            width={443}
            height={100}
            loading="lazy"
          />
        </div>
        <div className={styles.content}>
          <div className={styles.info}>
            <div className={styles.source}>{data.source}</div>
          </div>
          <div className={styles.text} dangerouslySetInnerHTML={{ __html: data.text }} />
        </div>
      </div>
    </a>
  )
}
